module.exports = __webpack_public_path__ + "img/Icono-celeste.fe440a57.png";